// Define Roles here as the Single Source of Truth
export const ROLES = {
    ClientsOptions: 'clients_options',
    ContractsOptions: 'contracts_options',
    UsersOptions: 'users_options',
    AnalysisOptions: 'analysis_options',
    WarrantiesOptions: 'warranties_options',
    SinisterOptions: 'sinister_options',
    SinisterValuesOptions: 'sinister_values_options',
    ReportsOptions: 'reports_options',
    FinancialOptions: 'financial_options',
    GeneralConditionsOptions: 'general_conditions_options',
    ChartsOptions: 'charts_options',
    PermissionsOptions: 'permissions_options',
    DashboardOptions: 'dashboard_options',
    MenuDashboard: 'menu_dashboard',
    ClientsDashboard: 'clients_dashboard',
    ContractsMenu: 'contracts_menu',
    UsersDashboard: 'users_dashboard',
    AnalysisDashboard: 'analysis_dashboard',
    WarrantiesMenu: 'warranties_menu',
    SinisterMenu: 'sinister_menu',
    ReportsMenu: 'reports_menu',
    FinancialMenu: 'financial_menu',
    GeneralConditionsMenu: 'general_conditions_menu',
    ChartsMenu: 'charts_menu',
    PermissionsMenu: 'permissions_menu',
    ComissionOptions: 'comission_options',
    ComissionMenu: 'comission_menu',
    PeopleOptions: 'people_options',
    PeopleMenu: 'people_menu',
    SignatureMenu: 'signature_menu',
    FireOptions: 'fire_options',
    FirePolicesOptions: 'fire_polices_options',
    FireFinancialOptions: 'fire_financial_options',
    FireMenu: 'fire_menu',
    BannerOptions: 'banner_options',
    BannerMenu: 'banner_menu',
    CapitalizationOptions: 'capitalization_options',
    CapitalizationMenu: 'capitalization_menu',
} as const;

export type PermissionRole = typeof ROLES[keyof typeof ROLES];

// Define Actions here as the Single Source of Truth
export const ACTIONS = {
    Add: 'add',
    Conclude: 'conclude',
    Filter: 'filter',
    Update: 'update',
    View: 'view',
    Cancel: 'cancel',
    Approve: 'approve',
    Reject: 'reject',
    Contest: 'contest',
    Serasa: 'serasa',
    LogSerasa: 'logSerasa',
    CreditDetails: 'creditDetails',
    ViewBiometry: 'viewBiometry',
    ViewSignedWarrantyContract: 'viewSignedWarrantyContract',
    ResendAnalysis: 'resendAnalysis',
    ClickSign: 'clickSign',
    Tipping: 'tipping',
    UpProposalPeriod: 'upProposalPeriod',
    UpProposalValues: 'upProposalValues',
    UpProposalAddress: 'upProposalAddress',
    UpProposalLocator: 'upProposalLocator',
    UpProposalCancel: 'upProposalCancel',
    UpProposalConcludeCancel: 'upProposalConcludeCancel',
    ReportFinancial: 'reportFinancial',
    ReportProposals: 'reportProposals',
    ReportAnalysis: 'reportAnalysis',
    ReportSinister: 'reportSinister',
    ReportAdmin: 'reportAdmin',
    ReportClient: 'reportClient',
    ReportLogAndAudit: 'reportLogAndAudit',
    BlockCancel: 'blockCancel',
    BlockMenuView: 'blockMenuView',
    BlockNotify: 'blockNotify',
    BlockClient: 'blockClient',
    WalletTransfer: 'walletTransfer',
    Contracts: "contracts",
    ContractsDetails: "contractsDetails",
    ContractsAdd: "contractsAdd",
    ContractsUpdate: "contractsUpdate",
    ContractsShoot: "contractsShoot",
    Biometria: "biometria",
    People: "people",
    Calculate: "calculate",
    Print: "print",
    Renew: "renew",
    Preview: "preview",
    Invoice: "invoice",
    Prolabore: "prolabore",
    Boleto: "boleto",
    AlterStatus: "alterStatus",
    UpdatePlans: "updatePlans",
    RevertAnalysis: "revertAnalysis",
    DisableSerasa: "disableSerasa",
    SetupFee: "setupFee",
    SolidaryTenant: "solidaryTenant",
    AttachFiles: "attachFiles",
    AdjustInstallments: "adjustInstallments",
    SetInstallmentsPaid: "setInstallmentsPaid",
    CancelInstallments: "cancelInstallments",
    ReactivateInstallments: "reactivateInstallments",
    LaunchFinancialValues: "launchFinancialValues",
    CommissionLaunchBatch: "commissionLaunchBatch",
    CommissionCancelBatch: "commissionCancelBatch",
    CommissionReactivateBatch: "commissionReactivateBatch",
    CommissionLaunchSingle: "commissionLaunchSingle",
    CommissionCancelSingle: "commissionCancelSingle",
    CommissionViewDetails: "commissionViewDetails",

    // Financeiro > Reajustes
    ReadjustView: "readjustView",
    ReadjustAdd: "readjustAdd",
    ReadjustUpdate: "readjustUpdate",

    // Usuários
    ResetPassword: "resetPassword",

	// Clientes
	ActivatePartners: "activatePartners",

    // Análises
    ConvertAnalysisToPj: "convertAnalysisToPj",

    // Sinistro > Valores
    ViewBordero: "viewBordero",
    GenerateBordero: "generateBordero",
} as const;

export type PermissionAction = typeof ACTIONS[keyof typeof ACTIONS];

export interface PermissionModuleConfig {
    key: PermissionRole;
    label: string;
    type: 'menu' | 'options';
    actions: { action: PermissionAction; label: string; group?: string }[];
}

export const PERMISSIONS_CONFIG: PermissionModuleConfig[] = [
    {
        key: ROLES.MenuDashboard,
        label: 'Dashboard',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ClientsDashboard,
        label: 'Clientes',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ContractsMenu,
        label: 'Contratos',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.UsersDashboard,
        label: 'Usuários',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.AnalysisDashboard,
        label: 'Análises',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.WarrantiesMenu,
        label: 'Garantias',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.SinisterMenu,
        label: 'Sinistro',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.FireMenu,
        label: 'Incêndio',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ReportsMenu,
        label: 'Relatórios',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.FinancialMenu,
        label: 'Financeiro',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ComissionMenu,
        label: 'Premiação zz',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.GeneralConditionsMenu,
        label: 'Documentos para Download',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.ChartsMenu,
        label: 'Gráficos',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.PermissionsMenu,
        label: 'Permissões',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.PeopleMenu,
        label: 'BlackList',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.SignatureMenu,
        label: 'Assinatura Eletronica',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },


    // --- OPTIONS PERMISSIONS ---
    {
        key: ROLES.DashboardOptions,
        label: 'Dashboard',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.ClientsOptions,
        label: 'Clientes',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.WalletTransfer, label: 'Transferência de Carteira' },
			{ action: ACTIONS.ActivatePartners, label: 'Ativar/Desativar Parceiros' },
        ]
    },
    {
        key: ROLES.ContractsOptions,
        label: 'Contratos',
        type: 'options',
        actions: [
            { action: ACTIONS.Contracts, label: 'Visualizar/Listar Contratos' },
            { action: ACTIONS.ContractsDetails, label: 'Detalhes do Contrato' },
            { action: ACTIONS.ContractsAdd, label: 'Novo Contrato' },
            { action: ACTIONS.ContractsUpdate, label: 'Editar Contrato' },
            { action: ACTIONS.ContractsShoot, label: 'Disparar Contrato' },
        ]
    },
    {
        key: ROLES.UsersOptions,
        label: 'Usuários',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.ResetPassword, label: 'Reset Senha' }
        ]
    },
    {
        key: ROLES.AnalysisOptions,
        label: 'Análises',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar', group: 'Geral' },
            { action: ACTIONS.Add, label: 'Adicionar', group: 'Geral' },
            { action: ACTIONS.Update, label: 'Atualizar', group: 'Geral' },
            { action: ACTIONS.Filter, label: 'Filtrar', group: 'Geral' },

            { action: ACTIONS.Conclude, label: 'Concluir', group: 'Fluxo' },
            { action: ACTIONS.AlterStatus, label: 'Alterar Status', group: 'Fluxo' },
            { action: ACTIONS.RevertAnalysis, label: 'Reverter Análises', group: 'Fluxo' },

            { action: ACTIONS.Serasa, label: 'Consultar Serasa', group: 'Serasa' },
            { action: ACTIONS.DisableSerasa, label: 'Desativar envio Serasa', group: 'Serasa' },

            { action: ACTIONS.LogSerasa, label: 'Log Serasa', group: 'Logs' },
            { action: ACTIONS.CreditDetails, label: 'Detalhes do Crédito', group: 'Logs' },

            { action: ACTIONS.ViewBiometry, label: 'Ver Biometria', group: 'Biometria' },
            { action: ACTIONS.Biometria, label: 'Reenviar Biometria', group: 'Biometria' },

            { action: ACTIONS.ResendAnalysis, label: 'Reenviar Análise', group: 'Fluxo' },
            { action: ACTIONS.UpdatePlans, label: 'Atualizar Planos Análise', group: 'Fluxo' },
            { action: ACTIONS.SolidaryTenant, label: 'Locatário Solidário', group: 'Extras' },
            { action: ACTIONS.ConvertAnalysisToPj, label: 'Converter análise para PJ', group: 'Extras' },
            { action: ACTIONS.SetupFee, label: 'Cobrar Taxa de Setup', group: 'Extras' },
            { action: ACTIONS.Tipping, label: 'Tombamento', group: 'Extras' },
            { action: ACTIONS.ClickSign, label: 'Enviar clickSign', group: 'Extras' }
        ]
    },
    {
        key: ROLES.WarrantiesOptions,
        label: 'Garantias',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.Cancel, label: 'Cancelar' },
            { action: ACTIONS.UpProposalPeriod, label: 'Alterar Vigência' },
            { action: ACTIONS.UpProposalValues, label: 'Alterar Valores' },
            { action: ACTIONS.UpProposalAddress, label: 'Alterar Endereço' },
            { action: ACTIONS.UpProposalLocator, label: 'Alterar Locador' },
            { action: ACTIONS.UpProposalCancel, label: 'Alterar Cancelamento' },
            { action: ACTIONS.UpProposalConcludeCancel, label: 'Concluir Cancelamento' },
            { action: ACTIONS.ViewSignedWarrantyContract, label: 'Visualizar Contrato Assinado' }
        ]
    },
    {
        key: ROLES.SinisterOptions,
        label: 'Sinistro',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.Cancel, label: 'Cancelar' }
        ]
    },
    {
        key: ROLES.SinisterValuesOptions,
        label: 'Valores de Sinistro',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.Cancel, label: 'Cancelar' },
            { action: ACTIONS.Approve, label: 'Aprovar' },
            { action: ACTIONS.Reject, label: 'Rejeitar' },
            { action: ACTIONS.Contest, label: 'Contestar' },
            { action: ACTIONS.ViewBordero, label: 'Visualizar Borderôs', group: 'Borderô' },
            { action: ACTIONS.GenerateBordero, label: 'Gerar Borderô', group: 'Borderô' }
        ]
    },
    {
        key: ROLES.ReportsOptions,
        label: 'Relatórios',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.ReportClient, label: 'Imobiliárias' },
            { action: ACTIONS.ReportAnalysis, label: 'Análises' },
            { action: ACTIONS.ReportProposals, label: 'Garantias' },
            { action: ACTIONS.ReportSinister, label: 'Sinistros' },
            { action: ACTIONS.ReportFinancial, label: 'Financeiros' },
            { action: ACTIONS.ReportAdmin, label: 'Administrativos' },
            { action: ACTIONS.ReportLogAndAudit, label: 'Auditoria e Logs' }
        ]
    },
    {
        key: ROLES.FinancialOptions,
        label: 'Financeiro',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar', group: 'Geral' },
            { action: ACTIONS.Add, label: 'Adicionar', group: 'Geral' },
            { action: ACTIONS.Update, label: 'Atualizar', group: 'Geral' },
            { action: ACTIONS.Filter, label: 'Filtrar', group: 'Geral' },

            { action: ACTIONS.CancelInstallments, label: 'Cancelar parcelas', group: 'Operações' },
            { action: ACTIONS.ReactivateInstallments, label: 'Reativar parcelas', group: 'Operações' },
            { action: ACTIONS.AdjustInstallments, label: 'Ajustar parcelas', group: 'Operações' },
            { action: ACTIONS.SetInstallmentsPaid, label: 'Baixar parcelas', group: 'Operações' },
            { action: ACTIONS.LaunchFinancialValues, label: 'Lançar valores', group: 'Operações' },

            { action: ACTIONS.BlockMenuView, label: 'Entrar no menu de bloqueios', group: 'Bloqueios' },
            { action: ACTIONS.BlockNotify, label: 'Notificar cliente', group: 'Bloqueios' },
            { action: ACTIONS.BlockClient, label: 'Bloquear imobiliária', group: 'Bloqueios' },

            { action: ACTIONS.CommissionLaunchBatch, label: 'Comissões - Lançar em lote', group: 'Comissões' },
            { action: ACTIONS.CommissionCancelBatch, label: 'Comissões - Cancelar em lote', group: 'Comissões' },
            { action: ACTIONS.CommissionReactivateBatch, label: 'Comissões - Reativar em lote', group: 'Comissões' },
            { action: ACTIONS.CommissionLaunchSingle, label: 'Comissões - Lançar individual', group: 'Comissões' },
            { action: ACTIONS.CommissionCancelSingle, label: 'Comissões - Cancelar individual', group: 'Comissões' },
            { action: ACTIONS.CommissionViewDetails, label: 'Comissões - Ver detalhes', group: 'Comissões' },

            { action: ACTIONS.ReadjustView, label: 'Ver reajuste', group: 'Reajustes' },
            { action: ACTIONS.ReadjustAdd, label: 'Incluir reajuste', group: 'Reajustes' },
            { action: ACTIONS.ReadjustUpdate, label: 'Alterar reajuste', group: 'Reajustes' }
        ]
    },
    {
        key: ROLES.GeneralConditionsOptions,
        label: 'Condições Gerais',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.ChartsOptions,
        label: 'Gráficos',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.PermissionsOptions,
        label: 'Permissões',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.ComissionOptions,
        label: 'Comissão',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.Cancel, label: 'Cancelar' }
        ]
    },
    {
        key: ROLES.PeopleOptions,
        label: 'BlackList',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.FireOptions,
        label: 'Incêndio - Cotações',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Criar Cotação' },
            { action: ACTIONS.Calculate, label: 'Calcular' },
            { action: ACTIONS.Update, label: 'Editar' },
            { action: ACTIONS.Print, label: 'Imprimir' },
            { action: ACTIONS.Cancel, label: 'Cancelar' }
        ]
    },
    {
        key: ROLES.FirePolicesOptions,
        label: 'Incêndio - Apólices',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Print, label: 'Imprimir' },
            { action: ACTIONS.Cancel, label: 'Cancelar' },
            { action: ACTIONS.Renew, label: 'Renovar' }
        ]
    },
    {
        key: ROLES.FireFinancialOptions,
        label: 'Incêndio - Financeiro',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Preview, label: 'Prévia' },
            { action: ACTIONS.Invoice, label: 'Fatura' },
            { action: ACTIONS.Prolabore, label: 'Prolabore' },
            { action: ACTIONS.Boleto, label: 'Boleto' }
        ]
    },
    {
        key: ROLES.BannerMenu,
        label: 'Gestão de Banners',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.BannerOptions,
        label: 'Gestão de Banners',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Atualizar' },
            { action: ACTIONS.Filter, label: 'Filtrar' }
        ]
    },
    {
        key: ROLES.CapitalizationMenu,
        label: 'Capitalização',
        type: 'menu',
        actions: [{ action: ACTIONS.View, label: 'Visualizar' }]
    },
    {
        key: ROLES.CapitalizationOptions,
        label: 'Capitalização',
        type: 'options',
        actions: [
            { action: ACTIONS.View, label: 'Visualizar' },
            { action: ACTIONS.Add, label: 'Adicionar' },
            { action: ACTIONS.Update, label: 'Editar' },
            { action: ACTIONS.Filter, label: 'Filtrar' },
            { action: ACTIONS.AttachFiles, label: 'Anexos' }
        ]
    }
];
